import { proxy, useSnapshot } from "valtio";

interface IPhotoSortState {
	sortBy: eXpress.SortBy;
	sortDirection: eXpress.SortDirection;
}

const photoSortState = proxy<IPhotoSortState>({
	sortBy: eXpress.SortBy.DateTaken,
	sortDirection: eXpress.SortDirection.Ascending,
});

function setSortBy(value: eXpress.SortBy) {
	photoSortState.sortBy = value;
}

function setSortDirection(value: eXpress.SortDirection) {
	photoSortState.sortDirection = value;
}

export function usePhotoSort() {
	const { sortBy, sortDirection } = useSnapshot(photoSortState);

	return [
		{ sortBy, sortDirection },
		{ setSortBy, setSortDirection },
	] as const;
}
